<template>
  <!-- <el-dialog custom-class="amap-lookwz__dialog" :title="address" :append-to-body="true" width="1000px" :visible.sync="dialogFormVisible"> -->
  <div class="loninContaner" v-if="showLogin">
    <div class="overlay_bg"></div>
    <div id="dialog_tel" class="panel_login animated className">
      <div class="panel_info">
        <i class="close_login" @click="closeBox()">×</i>
        <div class="panel_tab clearfix">
          <div class="message_box">
            <div class="gzwxgzh">
              <div class="tishi">
                <div class="messageTitle"> 友情提醒：</div>
                <div class="content_desc"> 为了更好的体验您可以先关注微信公众号</div>
              </div>
              <div class="buzhou">
                <div class="messageTitle"> 关注步骤：</div>
                <p class="clearfix"><span class="title">1、</span><span class="content_desc">打开微信，扫码下方“二维码”打开连接。</span>
                </p>
                <p class="clearfix"><span class="title">2、</span><span class="content_desc">点击“关注”按钮关注微信公众号就可以了。</span>
                </p>
              </div>
            </div>
            <div class="gongzhonghao_code"><img src="https://www.yitku.com/home/images/ytk.jpg" />
              <p class="text">关注益题库</p>
            </div>
          </div>
          <div class="login_box" id='login_form' v-if="showTextLogin">
            <div class="title">
              <div class="fl">手机快捷登录</div>
              <div class="register_text_tel">需要先绑定过手机号才可以登录哦</div>
            </div>
            <div class="clear"></div>
            <div id="con_login_user_tel">
              <form action="" method="post">
                <ul>
                  <li class="item border-t userName">
                    <!-- <input type="text" class="the_input topSpecial users_tel" maxlength="11" id="loginname" placeholder="请输入手机号"> -->
                    <el-input class="the_input topSpecial users_tel" prefix-icon="el-icon-user" placeholder="请输入手机号"
                      maxlength="11" v-model="form_data.user_name" v-on:input="checkNumber(form_data.user_name)">
                    </el-input>
                  </li>
                  <li class="item border-b Verify">
                    <!-- <input type="text" class="the_input verifycode" maxlength="6" id="loginpassword" placeholder="请输入短信验证码"> -->
                    <el-input class="the_input verifycode" prefix-icon="el-icon-lock" placeholder="请输入短信验证码"
                      v-model="form_data.passWord" v-on:input="checkPwd(form_data.passWord)">
                    </el-input>
                    <!-- <a class="send_verify_code" id="" rel="nofollow"><em>获取验证码</em></a> -->
                    <a class="send_verify_code" v-on:click="sentCode">{{ beginning ? time + 's' : btnText }}</a>
                  </li>
                  <li class="show-error" id="loginerror">
                    <dd>用户名或密码错误</dd>
                  </li>
                  <li class="li_01">
                    <label class="checkbox-btn" id='qitian_login'><span class="active">
                        <input type="checkbox" name="remember" value="1" class="mind-login" checked="">
                      </span>7天内免登录</label>
                  </li>
                  <li class="li_btn">
                    <el-button v-on:click="Login" type="primary" :loading="loading"
                      class="login-user-tel-btn">立即登录</el-button>
                    <!-- <a class="login-user-tel-btn" id='login-submit-btn'>立即登录</a> -->
                  </li>
                </ul>
              </form>
            </div>
          </div>
          <form id="signup-form" v-else>
            <div class="title">
              <div class="fl">扫码快捷登录</div>
              <div class="register_text_tel">打开微信扫一扫登录方便快捷,更省时省力！</div>
            </div>
            <div class="rlf-group proclaim-loc js-proclaim-on">
              <div class="qrcode">
                <img :src="Qrcode" style="width:160px;height:160px;" />
              </div>
              <p class="qrcode_title">扫描二维码登录</p>
              <p class="qrcode_mark">请使用 <a href="javascript:;" class="color-red">微信扫一扫</a> 扫码完成登录</p>
            </div>
          </form>
        </div>
      </div>
      <div class="registered"></div>
      <div :class="showTextLogin == true ? 'erweima' : 'erweima pcLogin'" @click="showBtnLogin()" dataType='login'
        id='qiehuan_denglufangshi'></div>
    </div>

    <el-dialog title="图片验证" :append-to-body="true" :visible.sync="dialogFormVisible" top="35vh"
      :close-on-click-modal="false" width="25%" center>
      <el-form :model="ruleForm">

        <el-form-item label="输入验证码：">
          <el-col :span="10">
            <el-input v-model="ruleForm.imgCode" autocomplete="off" placeholder="输入验证码："></el-input>
          </el-col>
          <el-col class="line" :span="1"></el-col>
          <el-col :span="6">
            <img @click="getImgCode" :src="imgUrl" height="40" alt style="cursor: pointer;" />
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="chekImageCode">确 定</el-button>
      </div>
    </el-dialog>

  </div>
  <!-- </el-dialog> -->
</template>
<script>
export default {
  name: "LoginBox",
  props: {
    showLogin: { default: true },
  }, //
  data() {
    return {
      loading: false,
      dialogFormVisible: false,
      showTextLogin: false,
      formLabelWidth: "100px",
      form_data: {
        user_name: "",
        passWord: "",
      },
      ruleForm: {
        imgCode: "",
        imgKeys: "",
      },
      imgUrl: "",
      time: 60,
      btnText: "获取验证码",
      beginning: false,
      Qrcode: "https://img.233.com/loading2.gif",
      codeId: "",
    };
  },

  methods: {
    //请求小程序二维码
    getMiQrCode() {
      const that = this;
      console.log(1111);
      that.axios.post("/getLoginQrcode").then((res) => {
        if (res.code == 200) {
          that.Qrcode = "data:image/gif;base64," + res.data.base64;
          that.codeId = res.data.codeId;
          setInterval(function () {
            that.chkMiQrCode();
          }, 3000);
        } else {
          that.loading = false;
        }
      });
    },

    //定时任务检测是否扫码登录
    chkMiQrCode() {
      const that = this;
      that.axios
        .post("/chkLoginQrcode", {
          codeId: that.codeId,
        })
        .then((res) => {
          if (res.code == 200) {
            console.log(res);
            sessionStorage.setItem("access-token", res.data.token);
            sessionStorage.setItem("access-nick", res.data.users.nickname);
            //sessionStorage.setItem("access-users", res.data.users);
            sessionStorage.setItem("access-users", JSON.stringify(res.data.users));
            that.$message.success(res.msg);
            window.location.reload();
          } else {
            that.loading = false;
          }
        });
    },

    closeBox() {
      this.$emit("closeLogin", "子向父组件传值");
    },

    sentCode() {
      var that = this;
      if (that.beginning) return false;
      if (that.form_data.user_name === "") {
        that.$message({
          type: "error",
          message: `操作提示: ${"手机号不能为空"}`,
        });
        that.loading = false;
        return;
      }
      that.getImageCode();
      that.dialogFormVisible = true;
    },
    getImgCode() {
      var that = this;
      that.getImageCode();
    },
    checkNumber(val) {
      this.form_data.user_name = val;
    },
    checkPwd(val) {
      this.form_data.passWord = val;
    },

    getImageCode() {
      const that = this;
      that.axios.post("/getImageCode").then((res) => {
        console.log(res);
        if (res.code == 200) {
          that.imgUrl = res.data.img;
          that.ruleForm.imgKeys = res.data.key;
        } else {
          that.loading = false;
        }
      });
    },

    async getQrcodeCode() {
      const that = this;
      that.axios.post("/getWechatQrcode").then((res) => {
        console.log(res);
        if (res.code == 200) {
          that.Qrcode = res.data;
        } else {
          that.$message.error(res.msg);
        }
      });
    },

    async chekImageCode() {
      const that = this;
      if (that.beginning) return false;

      if (that.ruleForm.imgCode === "") {
        that.$message({
          type: "error",
          message: `操作提示: ${"图片验证码不能为空"}`,
        });
        return;
      }

      that.axios
        .post("/getMobileCode", {
          mobile: that.form_data.user_name,
          code: that.ruleForm.imgCode,
          key: that.ruleForm.imgKeys,
          type: 0,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            that.ruleForm.imgCode = "";
            that.dialogFormVisible = false;
            that.beginning = true;
            that.btnText = "重新获取";
            that.timer = setInterval(() => {
              let tempTime = that.time;
              if (tempTime == 0) {
                // 倒计时结束
                clearInterval(that.timer);
                that.beginning = false;
                that.time = 60;
                return;
              }
              that.time--;
            }, 1000);
          } else {
            that.ruleForm.imgCode = "";
            that.$message.error(res.msg);
            that.getImageCode();
          }
        });
    },

    async Login() {
      const that = this;
      that.loading = true;
      if (that.form_data.user_name === "") {
        that.$message({
          type: "error",
          message: `操作提示: ${"手机号不能为空"}`,
        });
        that.loading = false;
        return;
      }
      if (that.form_data.passWord === "") {
        that.$message({
          type: "error",
          message: `操作提示: ${"请您输入手机验证码"}`,
        });
        that.loading = false;
        return;
      }
      that.axios
        .post("/milogin", {
          mobile: that.form_data.user_name,
          msgcode: that.form_data.passWord,
        })
        .then((res) => {
          if (res.code == 200) {
            sessionStorage.setItem("access-token", res.data.token);
            sessionStorage.setItem("access-nick", res.data.users.nickname);
            //sessionStorage.setItem("access-users", res.data.users);
            sessionStorage.setItem("access-users", JSON.stringify(res.data.users));
            that.$message.success(res.msg);
            //this.$router.push("/web/index");
            window.location.reload();
          } else {
            that.loading = false;
            that.$message.error(res.msg);
          }
        });
    },

    showBtnLogin() {
      this.showTextLogin = !this.showTextLogin;
    },
  },
};
</script>

<style>
.clearfix {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

.loninContaner {
  position: relative;
  z-index: 999;
}

.loninContaner .overlay_bg {
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.6;
  filter: alpha(opacity=60);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 998;
}

.loninContaner .panel_login {
  width: 720px;
  height: auto;
  background-color: #fff;
  position: fixed;
  z-index: 999;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 1px 3px 14px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 1px 3px 14px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 1px 3px 14px rgba(0, 0, 0, 0.3);
  -o-box-shadow: 1px 3px 14px rgba(0, 0, 0, 0.3);
  /* display: none; */
  z-index: 999;
  border-radius: 2px;
}

.animated {
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.loninContaner .panel_login .panel_info {
  padding-top: 40px;
}

.loninContaner .panel_login .panel_info .close_login {
  cursor: pointer;
  position: absolute;
  right: 15px;
  top: 15px;
  padding: 4px;
  font-style: normal;
  font-size: 20px;
}

.loninContaner .panel_login .panel_tab .title {
  min-height: 20px;
  line-height: 20px;
  margin-bottom: 40px;
  padding-left: 0;
}

.loninContaner .panel_login .panel_tab .title .fl {
  font-size: 20px;
  color: #101d37;
  font-weight: bold;
}

.loninContaner .panel_login .panel_tab li.userName {
  padding: 0;
}

.loninContaner .panel_login .panel_tab li.pwd,
.loninContaner .panel_login .panel_tab li.userName {
  background: #fff;
}

.loninContaner .border-t {
  border: 1px solid #dbdbdb;
  border-radius: 2px 2px 0 0;
}

.loninContaner .panel_login .panel_tab li .the_input {
  width: 165px;
  height: 48px;
  line-height: 50px;
  color: #101d37;
  font-size: 14px;
  outline: none;
}

.loninContaner .panel_login .panel_tab li input {
  border: 0;
}

.loninContaner .panel_login .panel_tab li.pwd {
  padding: 0;
}

.loninContaner .panel_login .panel_tab li.pwd,
.loninContaner .panel_login .panel_tab li.userName {
  background: #fff;
}

.loninContaner .panel_login .panel_tab li input.password {
  margin-bottom: 8px;
  padding-right: 10px;
  width: 242px;
  box-sizing: content-box;
}

.loninContaner .panel_login .panel_tab li.checkVerimg {
  margin-top: -1px;
  padding: 0;
  border: 1px solid #dbdbdb;
}

.loninContaner .panel_login .panel_tab li.checkVerimg .ver-img {
  width: 151px;
  line-height: 50px;
  height: 50px;
  float: left;
}

.loninContaner .panel_login .panel_tab li a {
  color: #3d3d3d;
  float: right;
  font-size: 12px;
  width: 90px;
  text-align: center;
  cursor: pointer;
}

.loninContaner .send_verify_code {
  line-height: 50px;
}

.loninContaner .send_verify_code em {
  padding: 0 16px;
  border-left: 1px solid #dbdbdb;
  font-style: normal;
}

.loninContaner .panel_login .panel_tab .show-error,
.loninContaner .panel_login .panel_tab .send_verify_code_s {
  display: none;
  padding: 24px 0 0;
  height: 14px;
  line-height: 14px;
}

.loninContaner .panel_login .panel_tab li.send_verify_code_s {
  margin-left: 7px;
  color: #db4c3f;
  height: 30px;
  line-height: 30px;
}

.loninContaner .panel_login .panel_tab li a.voice_a {
  float: none;
  text-decoration: underline;
  color: #101d37;
  cursor: pointer;
}

.loninContaner .panel_login .panel_tab .show-error,
.loninContaner .panel_login .panel_tab .send_verify_code_s {
  display: none;
  padding: 24px 0 0;
  height: 14px;
  line-height: 14px;
}

.loninContaner .panel_login .panel_tab li.li_01 {
  line-height: 23px;
  padding: 24px 0;
  height: auto;
}

.loninContaner .panel_login .panel_tab li.li_01 label span {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 1px solid #dbdbdb;
  border-radius: 2px;
  position: relative;
  margin-right: 6px;
  float: none;
  vertical-align: -4px;
}

.loninContaner .register_text_tel {
  color: #aaa;
  padding: 25px 0 0;
  line-height: 1;
  font-size: 14px;
}

.checkbox-btn .active {
  background-image: url(../../public/images/checkbox_login.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 12px 12px;
}

.loninContaner .panel_login .panel_tab li.checkVerimg .verImg {
  float: right;
  height: 45px;
  width: 125px;
}

.loninContaner .panel_login .panel_tab li.li_btn {
  padding: 0;
}

.loninContaner .border-b {
  border: 1px solid #dbdbdb;
  border-top: none;
  border-radius: 0 0 2px 2px;
}

.loninContaner .panel_login .panel_tab li.li_01 .checkbox-btn {
  cursor: pointer;
}

.loninContaner .panel_login .panel_tab li .mind-login,
.loninContaner .panel_login .panel_tab li .read-protocol {
  float: none;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  opacity: 0;
}

.loninContaner .panel_login .panel_tab .login-user-tel-btn {
  display: inline-block;
  width: 100%;
}

.loninContaner .panel_login .panel_tab .current {
  opacity: 1;
}

.loninContaner .panel_login .panel_tab li a.active {
  color: #366dfa;
}

.loninContaner .panel_login .panel_tab .footer-link {
  padding: 24px 0 0;
  line-height: 14px;
}

.loninContaner .panel_login .panel_tab li {
  color: #555555;
  clear: both;
  height: 50px;
  position: relative;
}

.loninContaner .panel_login .panel_tab .footer-link a {
  color: #366dfa;
  float: none;
}

.loninContaner .registered {
  width: 380px;
  text-align: right;
  color: #555;
  padding: 10px 0 25px 0;
  margin-top: 5px;
}

.loninContaner .panel_login .panel_tab .show-error dd {
  top: 0;
  display: block;
  color: #db4c3f;
}

/*二维码*/
.loninContaner .erweima,
.pcLogin {
  background: url(../../public/images/erweima_icon.png) no-repeat 0 0;
  width: 60px;
  height: 60px;
  position: absolute;
  bottom: 0;
  right: 0;
  cursor: pointer;
  border-radius: 0 0 12px 0;
}

.loninContaner .pcLogin {
  background: url(../../public/images/pcLogin_icon.png) no-repeat 0 0;
}

.loninContaner .rl-modal .proclaim-loc {
  position: relative;
}

.loninContaner .qrcode {
  position: relative;
  width: 160px;
  height: 160px;
  margin: auto;
  margin-bottom: 30px;
}

.loninContaner .qrcode_title {
  font-size: 16px;
  color: #717a84;
  font-weight: 700;
  text-align: center;
  margin-bottom: 5px;
}

.loninContaner .qrcode_mark {
  color: #717a84;
  font-size: 12px;
  text-align: center;
}

.loninContaner .color-red {
  color: #366dfa !important;
}

/*关注公众号提示*/
.loninContaner .panel_tab>div,
.loninContaner .panel_tab>form {
  float: left;
  width: 406px;
  padding-right: 60px;
  height: 392px;
}

.loninContaner .login_box {
  padding-right: 50px;
}

.loninContaner .panel_tab>.message_box {
  width: 260px;
  padding-left: 40px;
  position: relative;
  left: 0;
  top: 0;
  padding-right: 30px;
  margin-right: 50px;
}

.loninContaner .panel_tab>.message_box:after {
  border-right: 1px solid #eee;
  content: "";
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  height: 370px;
}

.loninContaner .panel_tab>.message_box .tishi {
  margin: 15px 0;
}

.message_box {
  width: 120px;
  height: 120px;
}

.message_box .gzwxgzh .messageTitle {
  font-size: 14px;
  color: #101d37;
  font-weight: 700;
  padding-bottom: 10px;
}

.message_box .gzwxgzh .tishi .content_desc {
  margin-top: 0;
  padding-bottom: 10px;
  color: #9199a1;
  padding-top: 0;
  font-size: 12px;
}

.message_box .gzwxgzh .buzhou p {
  color: #9199a1;
  font-size: 14px;
  padding-left: 5px;
  padding-bottom: 10px;
}

.message_box .gzwxgzh .buzhou p>span {
  float: left;
  display: block;
}

.message_box .gzwxgzh .buzhou p .title {
  width: 20px;
  color: #366dfa;
  font-weight: 700;
  margin-bottom: 0;
}

.message_box .gzwxgzh .buzhou p .content_desc {
  width: 220px;
  margin-top: -1px;
  padding-top: 0;
  padding-bottom: 0;
  line-height: 1.5;
  font-size: 12px;
}

.message_box .gongzhonghao_code {
  width: 110px;
  height: 110px;
  margin: auto;
  margin-top: 10px;
}

.message_box .gongzhonghao_code img {
  width: 100%;
  display: block;
}

.message_box .gongzhonghao_code .text {
  margin-top: 5px;
  font-size: 14px;
  color: #101d37;
  text-align: center;
}

.loninContaner .panel_login .panel_info .panel_tab {
  width: 720px;
}
</style>